import React from "react";
import { Linkedin } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  name: "Samuel Otieno",
  role: "Lead AI Consultant",
  bio: "Expert in AI implementation and machine learning with over 10 years of experience in the region. He drives innovation through predictive modeling and intelligent automation strategies.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558991/img/samuel_otieno_headshot.png",
  linkedin: "https://www.linkedin.com"
}, {
  name: "Amina Mohamed",
  role: "Cloud Solutions Architect",
  bio: "Specialist in cloud infrastructure, migration, and automation, serving clients across East Africa. Amina ensures seamless digital transitions with robust, scalable cloud architectures.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558991/img/amina_mohamed_headshot.png",
  linkedin: "https://www.linkedin.com"
}, {
  name: "David Kimani",
  role: "Head of Digital Strategy",
  bio: "A visionary strategist helping enterprises align technology with business goals for maximum ROI. David specializes in digital transformation roadmaps for high-growth sectors.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558991/img/david_kimani_headshot.png",
  linkedin: "https://www.linkedin.com"
}, {
  name: "Sarah Wanjiku",
  role: "Senior Data Engineer",
  bio: "Architecting complex data pipelines that turn raw information into actionable business insights. Sarah empowers organizations to make data-driven decisions with confidence.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558991/img/sarah_wanjiku_headshot.png",
  linkedin: "https://www.linkedin.com"
}];
export default function ArchitectsOfChange() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="architects-of-change" ref={ref} className={`dark bg-background text-foreground py-24 px-4 md:px-8 transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 text-center">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4">
            Architects of <span className="text-primary">Change</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            Meet the elite team of visionaries and engineers driving digital
            transformation across Kenya and East Africa.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers.map((member, i) => <div key={i} data-index={i} className="group relative h-full">
              <Card className="h-full border-border/50 bg-card/50 backdrop-blur-sm overflow-hidden hover:border-primary/50 transition-colors duration-500 flex flex-col">
                {}
                <div className="relative h-72 w-full overflow-hidden bg-muted">
                  <img src={member.image} alt={member.name} className="h-full w-full object-cover object-top transition-all duration-700 grayscale group-hover:grayscale-0 group-hover:scale-105" />
                  {}
                  <div className="absolute inset-0 bg-gradient-to-t from-background/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>

                {}
                <CardContent className="flex flex-col flex-grow p-6 relative">
                  <div className="mb-4">
                    <h3 className="text-xl font-bold text-foreground group-hover:text-primary transition-colors duration-300">
                      {member.name}
                    </h3>
                    <p className="text-sm font-medium text-primary/80 uppercase tracking-wider mt-1">
                      {member.role}
                    </p>
                  </div>
                  
                  <p className="text-muted-foreground text-sm leading-relaxed mb-8 flex-grow">
                    {member.bio}
                  </p>

                  {}
                  <div className="absolute bottom-4 right-4">
                    <Link to={member.linkedin} newTab className="inline-block" aria-label={`LinkedIn profile of ${member.name}`}>
                      <Button variant="ghost" size="icon" className="rounded-full hover:bg-primary/10 hover:text-primary transition-colors">
                        <Linkedin className="h-5 w-5" />
                      </Button>
                    </Link>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}